
const initState = {
    userName: localStorage.getItem('userName'),
    userLogin: localStorage.getItem('userLogin'),
    userGroups: localStorage.getItem('userGroups'),
    userPhoto: localStorage.getItem('userPhoto'),
    isLogged: localStorage.getItem('isLogged') === 'true',
    shouldConfirmEmail: JSON.parse(localStorage.getItem('shouldConfirmEmail')),
    confirmEmailDaysLeave: localStorage.getItem('confirmEmailDaysLeave')
}


export default (state = initState, action) => {

    Object.keys(initState).map((key) => {
        if (initState[key] === 'undefined') {
            initState[key] = '';
        }
    })


    switch (action.type) {
        case 'signIn':
            sessionStorage.removeItem('menuItems');
            localStorage.setItem('userName', action.userName);
            localStorage.setItem('userLogin', action.userLogin);
            localStorage.setItem('userGroups', action.userGroups);
            localStorage.setItem('isLogged', action.isLogged);
            localStorage.setItem('userPhoto', action.userPhoto);
            localStorage.setItem('shouldConfirmEmail', action.shouldConfirmEmail);
            localStorage.setItem('confirmEmailDaysLeave', action.confirmEmailDaysLeave);

            return {
                ...state,
                userName: action.userName,
                userLogin: action.userLogin,
                userGroups: action.userGroups,
                isLogged: action.isLogged,
                userPhoto: action.userPhoto,
                shouldConfirmEmail: action.shouldConfirmEmail,
                confirmEmailDaysLeave: action.confirmEmailDaysLeave,
            };
        case 'logout':
            sessionStorage.removeItem('menuItems');
            localStorage.removeItem('userName');
            localStorage.removeItem('userLogin');
            localStorage.removeItem('isLogged');
            localStorage.removeItem('userPhoto');
            localStorage.removeItem('userGroups');
            localStorage.removeItem('stat-sf');
            localStorage.removeItem('stat-marketing');
            localStorage.removeItem('shouldConfirmEmail');
            localStorage.removeItem('confirmEmailDaysLeave');

            return {
                ...state, userName: '', userLogin: '', isLogged: '',
                userPhoto: '', userGroups: '', shouldConfirmEmail: null, confirmEmailDaysLeave: null
            };
        case 'refreshUserInfo':
            localStorage.setItem('userName', action.userName);
            localStorage.setItem('userPhoto', action.userPhoto);
            localStorage.setItem('shouldConfirmEmail', action.shouldConfirmEmail);
            localStorage.setItem('confirmEmailDaysLeave', action.confirmEmailDaysLeave);

            return {
                ...state,
                userName: action.userName,
                userPhoto: action.userPhoto,
                shouldConfirmEmail: action.shouldConfirmEmail,
                confirmEmailDaysLeave: action.confirmEmailDaysLeave
            };
        default:
            return {...state}
    }
}
